import styled from 'styled-components';

import { BREAKPOINTS } from '../../../../../common/styles/style-constants';

export const NewPatientExamContainer = styled.div`
  width: 100%;
  display: flex;
  margin-top: 12px;

  & > div {
    flex-grow: 1;
  }

  & label {
    width: auto;
  }
`;

export const TreatmentsContainer = styled.div`
  & label {
    @media (min-width: ${BREAKPOINTS.tabletMin}px) {
      width: 274px;
    }
  }
`;

export const OtherInputContainer = styled.div`
  @media (min-width: ${BREAKPOINTS.tabletMin}px) {
    padding: 0 6px;
  }
`;

export const SubmitContainer = styled.div`
  margin: 20px 0 0 0;
  display: flex;
  justify-content: center;
`;
